import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Budget, SubBudget, Material } from '../../budget/interfaces/index';
import { DataService } from '../../services/data.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { unities } from '../../interfaces/unit';
import { OrderEntry } from '../interfaces/order';
import { Subscription } from 'rxjs/Subscription';
import { switchMap, startWith, map } from 'rxjs/operators';
import { ProjectNrPipe } from '../../shared/pipes/project-nr.pipe';

const guid = function() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

@Component({
  selector: 'app-order-entry-control',
  templateUrl: 'order-entry.component.html',
  styleUrls: ['./order-entry.component.scss']
})
export class OrderEntryComponent implements OnInit, OnDestroy {

  public materials: Observable<Partial<Material>[]>;

  @Input()
  public index: number;
  @Input()
  public isInvoicesAndDdt: boolean;

  private _item: FormGroup;

  @Input()
  public set item(i: FormGroup) {
    this._item = i;
    console.dir(this._item.value);
    this.total = this.calculateTotal(this._item.value);
  }

  public get item(): FormGroup {
    return this._item;
  }

  @Output()
  public removed: EventEmitter<number> = new EventEmitter<number>();

  unities = unities;
  total = 0;

  private budgetSubscription: Subscription;
  public budgets: BehaviorSubject<Partial<Budget>[]> = new BehaviorSubject([]);
  public subbudgets: BehaviorSubject<Partial<SubBudget>[]> = new BehaviorSubject([]);
  public filteredBudgets: Observable<Partial<Budget>[]>;

  public selectedBudget: BehaviorSubject<Budget> = new BehaviorSubject(null);
  public selectedSubBudget: BehaviorSubject<SubBudget> = new BehaviorSubject(null);

  private _doNotUpdateValues = false;

  constructor(private dataService: DataService, private projectNrPipe:  ProjectNrPipe) { }

  static calculateEntryValue(orderEntry: OrderEntry) {
    return (orderEntry.costEach * orderEntry.quantity) * (1 - orderEntry.discount / 100);
  }

  static buildItem(item?: OrderEntry) {
    if (item) {

      return new FormGroup({
        id: new FormControl(item.id),
        budget: new FormControl(item.budget, Validators.required),
        subBudget: new FormControl(item.subBudget, Validators.required),
        material: new FormControl(item.material, Validators.required),
        description: new FormControl(item.description, Validators.required),
        quantity: new FormControl(item.quantity, Validators.required),
        costEach: new FormControl(item.costEach, Validators.required),
        discount: new FormControl(item.discount),
        unit: new FormControl(item.unit, Validators.required),
        code: new FormControl(item.code),
        ddt: new FormControl(item.ddt),
        invoices: new FormControl(item.invoices)
      });
    } else {
      return new FormGroup({
        id: new FormControl(guid()),
        budget: new FormControl(undefined, Validators.required),
        subBudget: new FormControl(undefined, Validators.required),
        material: new FormControl(undefined, Validators.required),
        description: new FormControl('', Validators.required),
        quantity: new FormControl(undefined, Validators.required),
        costEach: new FormControl(undefined, Validators.required),
        discount: new FormControl(0),
        unit: new FormControl(undefined, Validators.required),
        code: new FormControl(),
        ddt: new FormControl(undefined),
        invoices: new FormControl(undefined)
      });
    }
  }

  compareSubBudget(sb1, sb2) {
    if (!sb1 || !sb2) {
      return false;
    }
    return sb1.created.getTime() === sb2.created.getTime();
  }

  compareMaterial(mat1, mat2) {
    if (!mat1 || !mat2) {
      return false;
    }
    return mat1.id === mat2.id;
  }

  public updateValues = () => {
    const val = this._doNotUpdateValues;
    return !val;
  }

  public setUpdateValues() {
    this._doNotUpdateValues = false;
  }

  ngOnInit() {

    // const selectedSubBudget = this.item.get('subBudget').value;
    // // this.item.get('subBudget').reset();

    console.log('Selected budget is', this.selectedBudget.value);

    this.budgetSubscription = this.selectedBudget
    .filter((budget) => (budget != null))
    .switchMap((budget) => {
      return this.dataService.getSubBudgetCollectionSnapshot(budget.id);
    })
    .do((sbList) => console.log('switch map triggered', sbList))
    .map((sbList) => {
      const sbListFiltered = sbList.filter( sb => {
        return !sb.payload.doc.data().deleted;
      });

      return sbListFiltered.map((sb) => {
          const data = sb.payload.doc.data() as SubBudget;
          const id = sb.payload.doc.id;
          return { id, ...data };
        });
    })
    .subscribe(this.subbudgets);

    if (this.item.get('budget').value) {
      console.log('Budget init is valid', this.item.get('budget').value);
      this.selectedBudget.next(this.item.get('budget').value);
    }

    if (this.item.get('subBudget').value) {
      console.log('Sub Budget init is valid', this.item.get('subBudget').value);
      this.selectedSubBudget.next(this.item.get('subBudget').value);
    }

    if (this.item.get('material').value) {
      console.log('material init is valid', this.item.get('material').value);
      // Prevent values update
      this._doNotUpdateValues = true;
    }


    // const bs = this.dataService.getProjectList()
    const bs = this.dataService.getBudgetList()
      .map(budgets =>
        budgets.filter(budget => budget.status !== 'archived')
        .map((b) => {
          const retB = this._project({ budgetNr: 1, id: 1, project: 1 })(b);
          if ('prosperworks' in b) {
            retB.prosperworks = {
              company_name: b.prosperworks.company_name
            };
          }
          return retB;
        })
      )
      .subscribe(this.budgets);

      this.budgetSubscription.add(bs);

    // this.dataService.getAllCompanies()
    //   .map((list) => list.filter((c) => (c.contact_type_id !== 764799)))
    //   .do((filteredList) => { console.log('People list', filteredList); })
    //   .subscribe(this.vendors);

    this.filteredBudgets = this.item.get('budget').valueChanges
      .do(console.log)
      .pipe(
        startWith({} as Budget),
        map(budget => budget && typeof budget === 'object' ? budget.budgetNr : String(budget)),
        map(budgetNr => budgetNr ? this.filterBudget(budgetNr) : this.budgets.value.slice())
      );

      const sbs = this.item.get('subBudget').valueChanges
      .subscribe(this.selectedSubBudget);

      this.budgetSubscription.add(sbs);


    this.materials = this.selectedSubBudget
      .filter((subBudget) => subBudget !== null)
      // .do((subBudget) => {
      //   this.item.get('material').reset('');
      // })
      .switchMap((subBudget) => {
        return this.dataService.getSBMaterials(this.selectedBudget.value.id, subBudget.id);
      })
      .map((matList) => matList.map((act) => {
        const data = act.payload.doc.data() as Material;
        const id = act.payload.doc.id;
        return { id: id, ...data };
      })
      )
      .do((actList) => {
        this.item.get('material').enable();
      });

    this.item.get('material').valueChanges
      .filter(m => m)
      .filter(this.updateValues)
      .do(console.log)
      .subscribe((m: Material) => {
        this.item.patchValue({
          costEach: m.costEach,
          quantity: m.quantity,
          unit: m.unit
        });
        this.total = this.calculateTotal(this.item.value);
      });

    Observable.merge(
      this.item.get('costEach').valueChanges,
      this.item.get('quantity').valueChanges,
      this.item.get('discount').valueChanges,
    )
      .map((m) => this.item.value)
      .subscribe((m) => {
        this.total = this.calculateTotal(m);
      });
  }

  private calculateTotal(orderEntry: OrderEntry) {
    return OrderEntryComponent.calculateEntryValue(orderEntry);
  }

  // private filterBudget(val: string): Partial<Budget>[] {
  //   return this.budgets.value
  //     .filter(option => {
  //       if (option.project) {
  //         return (option.project.internal ? 'i' : '' + option.project.projectNr.toString()).toLowerCase().indexOf(val.toLowerCase()) === 0;
  //       } else {
  //         return option.budgetId.toLowerCase().indexOf(val.toLowerCase()) === 0;
  //       }
  //     });
  // }

  private filterBudget(val: string): Partial<Budget>[] {
    return this.budgets.value
      .filter(option => {
        if (option.budgetNr) {
          let searchString = option.budgetNr;
          if (option.project) {
            searchString +=   this.projectNrPipe.transform(option);
          }
          if (option.companyName) {
            searchString += option.companyName;
          } else if (option.prosperworks && option.prosperworks.company_name) {
            searchString += option.prosperworks.company_name;
          }
          return searchString.toLowerCase().indexOf(val.toLowerCase()) !== -1;
        } else {
          return option.budgetId.toLowerCase().indexOf(val.toLowerCase()) === 0;
        }
      });
  }

  public budgetDisplayFn = (budget: Budget): string => {
    if (budget) {
      let ret  = (budget.project) ? this.projectNrPipe.transform(budget) : budget.budgetNr;
      if (budget.companyName) {
        ret += ' ' + budget.companyName;
      } else if (budget.prosperworks && budget.prosperworks.company_name) {
        ret += ' ' + budget.prosperworks.company_name;
      }
      return ret;
    } else {
      return null;
    }
  }

  public budgetChange($event) {
    if (!$event.option.value.id) {
      return;
    }
    this.item.get('material').reset('');
    this.selectedBudget.next($event.option.value);
  }

  private _project(projection: object) {
    return function (object: any): Partial<any> {
      const returnObject = {};
      for (const prop in projection) {
        if (prop && (prop in object)) {
          returnObject[prop] = object[prop];
        }
      }
      return returnObject;
    };
  }

  public ngOnDestroy() {
    if (this.budgetSubscription) {
     this.budgetSubscription.unsubscribe();
    }
  }

}

/*
export interface OrderEntry {
  description: string;
  budgetId: string;
  subBudgetId: string;
  materialId: string;
  value: number;
}
*/



// WEBPACK FOOTER //
// ./src/app/order/components/order-entry.component.ts